// extracted by mini-css-extract-plugin
export default {"NavigationItems":"NavigationItems_NavigationItems__uGtiO","NavigationItemIcon":"NavigationItems_NavigationItemIcon__ijXqe"};